import React from 'react';

import { Button } from '@epoch-ui/components/Button/button';
import { Icon } from '@epoch-ui/components/Icon';
import { SheetHeader } from '@epoch-ui/components/Sheet/sheet';
import { QUESTION_TYPE } from 'types/question.types';
import {
  customQuestionTypes,
  engagementMetricTypes
} from '@event-editor/components/EditQuestionSideSheet/questionTypes';

interface FeedbackQuestionTypeSelectorProps {
  onSelect: (type: QUESTION_TYPE) => void;
}

export const FeedbackQuestionTypeSelector: React.FC<FeedbackQuestionTypeSelectorProps> = ({
  onSelect
}) => {
  return (
    <>
      <SheetHeader className="tw-align-start tw-mb-0 tw-flex-shrink-0 tw-pb-0">
        <div className="tw-mb-2 tw-text-left tw-text-xl tw-font-medium tw-leading-7 tw-text-black">
          Add question
        </div>
      </SheetHeader>

      <div className="tw-flex tw-flex-grow tw-flex-col tw-gap-6 tw-overflow-auto">
        <div>
          <div className="tw-mb-3 tw-text-sm tw-leading-5">Custom questions</div>
          <div className="tw-flex tw-flex-col tw-gap-3">
            {customQuestionTypes.map(({ type, label, icon }) => (
              <Button
                key={type}
                variant="outline"
                className="tw-h-full tw-w-full tw-content-start tw-gap-2 tw-rounded-lg !tw-border-[2px] tw-p-2 tw-text-left"
                onClick={(): void => onSelect(type)}
              >
                <span className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-[8px] tw-bg-light-grey tw-text-dark-black">
                  {icon}
                </span>
                <span className="tw-flex-1 tw-text-sm tw-font-medium tw-leading-4">{label}</span>
                <span className="tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-rounded-[8px] tw-text-dark-black">
                  <Icon name="arrow-right" />
                </span>
              </Button>
            ))}
          </div>
          <div>
            <div className="tw-mb-3 tw-mt-6 tw-text-sm tw-leading-5">Engagement metrics</div>
            <div className="tw-flex tw-flex-col tw-gap-3">
              {engagementMetricTypes.map(({ type, label, icon }) => (
                <Button
                  key={type}
                  variant="outline"
                  className="tw-h-full tw-w-full tw-content-start tw-gap-2 tw-rounded-lg !tw-border-[2px] tw-p-2 tw-text-left"
                  onClick={(): void => onSelect(type)}
                >
                  <span
                    className={`tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center 
                      tw-rounded-[8px] tw-bg-light-grey tw-text-dark-black
                      [&>svg]:tw-h-[24px] [&>svg]:tw-w-[24px]`}
                  >
                    {icon}
                  </span>
                  <span className="tw-flex-1 tw-text-sm tw-font-medium tw-leading-4">{label}</span>
                  <span className="tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-rounded-[8px] tw-text-dark-black">
                    <Icon name="arrow-right" />
                  </span>
                </Button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
